import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/utils/api';

const API = process.env.REACT_APP_BACKEND_URL;

export const PioneerWall = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get('/pioneers/wall').then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="pioneer-wall-section">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-600 mb-2">Muro dos Pioneiros</p>
      <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight mb-8">Empresas pioneiras que confiam na Trabadju</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {items.map((p) => {
          const logo = (
            <img src={`${API}${p.logo_url}`} alt={p.company_name} loading="lazy" className="max-h-16 max-w-full object-contain grayscale group-hover:grayscale-0 transition-[filter] duration-300" />
          );
          const cls = 'group h-28 bg-white border border-slate-200 rounded-xl flex items-center justify-center p-4 hover:border-slate-900 transition-colors';
          return p.slug ? (
            <Link key={p.employer_id} to={`/empresa/${p.slug}`} className={cls} title={p.company_name} data-testid={`pioneer-logo-${p.employer_id}`}>{logo}</Link>
          ) : (
            <div key={p.employer_id} className={cls} title={p.company_name} data-testid={`pioneer-logo-${p.employer_id}`}>{logo}</div>
          );
        })}
      </div>
    </section>
  );
};
